<template>
  <input
    class="native-time-input"
    type="time"
    lang="en-GB"
    :value="formattedValue"
    :step="showSeconds ? 1 : 60"
    :disabled="disabled"
    :aria-label="ariaLabel"
    @input="handleInput"
  />
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  modelValue: {
    type: Date,
    default: null
  },
  showSeconds: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  },
  ariaLabel: {
    type: String,
    default: 'Time'
  }
});

const emit = defineEmits(['update:modelValue']);

const pad = value => String(value).padStart(2, '0');

const formattedValue = computed(() => {
  if (!(props.modelValue instanceof Date) || Number.isNaN(props.modelValue.getTime())) return '';

  const time = `${pad(props.modelValue.getHours())}:${pad(props.modelValue.getMinutes())}`;
  return props.showSeconds ? `${time}:${pad(props.modelValue.getSeconds())}` : time;
});

function handleInput(event) {
  const parts = event.target.value.split(':').map(Number);
  if (parts.length < 2 || parts.some(Number.isNaN)) return;

  const updatedValue = props.modelValue instanceof Date && !Number.isNaN(props.modelValue.getTime())
    ? new Date(props.modelValue)
    : new Date();
  updatedValue.setHours(parts[0], parts[1], parts[2] || 0, 0);
  emit('update:modelValue', updatedValue);
}
</script>

<style scoped>
.native-time-input {
  width: 100%;
  min-width: 8rem;
  padding: 3px 3px;
  color-scheme: dark;
}

.native-time-input:disabled {
  cursor: default;
}
</style>
